var React = require('react');

function CalendarOrganiser (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 3C9 1.34315 7.65685 0 6 0C4.34315 0 3 1.34315 3 3C3 4.65685 4.34315 6 6 6C7.65685 6 9 4.65685 9 3ZM12 9.5C10.6667 8.16667 8.66667 7.5 6 7.5C3.33333 7.5 1.33333 8.16667 0 9.5V12H12V9.5Z","fill":"currentColor"}));
}

CalendarOrganiser.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CalendarOrganiser;

CalendarOrganiser.default = CalendarOrganiser;
